<div *ngIf="!allowed">
    <div class="blank-layout-container justify-content-center align-items-center" style="background: linear-gradient(to bottom, #004c7a 50%, #FAFAFA 50%);">
        <div class="position-relative row w-100 h-100 bg-gredient justify-content-center">
            <div class="col-lg-4 d-flex align-items-center">
                <mat-card class="cardWithShadow boxed-auth" style="border-radius: 20px;box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;">
                    <mat-card-content class="p-32">
                        <div class="text-center">
                            <a href="javascript:;">
                                <img src="assets/images/logos/clu-logo.png" class="align-middle m-2" style="max-width: 150px;" alt="logo" />
                            </a>
                            <h2>Navigateur non supporté</h2>

                            <p>
                                Votre navigateur actuel :
                                <strong>{{ browserInfo.browser }} {{ browserInfo.version }}</strong>
                            </p>

                            <p>
                                Cette application nécessite
                                la dernière version de <strong>Google Chrome</strong> ou <strong>Microsoft Edge</strong>
                                pour fonctionner correctement (compatibilité RxDB).
                            </p>

                            <div class="links">
                                <a class="browser-block-link" href="https://www.google.com/chrome/" target="_blank">Télécharger Chrome</a>
                                <a class="browser-block-link" href="https://www.microsoft.com/edge" target="_blank">Télécharger Edge</a>
                            </div>
                        </div>

                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </div>

</div>
<ng-container *ngIf="allowed">
    <div class="zoom-control" *ngIf="isTauri">
      <button class="zoom-btn" (click)="zoomOut()"><i-tabler name="zoom-out" class="icon-12"></i-tabler></button>
      <span id="zoomValue" class="zoom-value">{{ zoomPercent }}%</span>
      <button class="zoom-btn" (click)="zoomIn()"><i-tabler name="zoom-in" class="icon-12"></i-tabler></button>
    </div>
    <div class="banner-container">
        <div class="banner banner-test" *ngIf="testMode">TEST</div>
        <div class="banner banner-env" *ngIf="!!appVersion.APP_ENVIRONMENT">{{ appVersion.APP_ENVIRONMENT }}</div>
        <div class="banner banner-licence" *ngIf="!!appVersion?.TYPE_LICENCE && appVersion.TYPE_LICENCE != TYPES_LICENCES.PROD">{{ TYPES_LICENCES_LABELS[appVersion.TYPE_LICENCE] }}</div>
    </div>
    <router-outlet></router-outlet>
</ng-container>
